import { Tabs } from "@mantine/core"
import { ScrollContainer } from "../../../-components/scroll-container"

type Tab<T> = {
  value: T
  label: string
  content: React.ReactNode
}

interface Props<T> {
  value: T
  onChange: (value: T) => void
  tabs: Tab<T>[]
}

export function DetailsTabs<T extends string>({
  tabs,
  value,
  onChange,
}: Props<T>): JSX.Element {
  return (
    <Tabs value={value} onChange={(value) => value && onChange(value as T)}>
      <Tabs.List>
        {tabs.map((tab, index) => (
          <Tabs.Tab key={index} value={tab.value}>
            {tab.label}
          </Tabs.Tab>
        ))}
      </Tabs.List>
      {tabs.map((tab, index) => (
        <Tabs.Panel key={index} value={tab.value}>
          <ScrollContainer>{tab.content}</ScrollContainer>
        </Tabs.Panel>
      ))}
    </Tabs>
  )
}
